import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Layout from '../appLayout';
const ProtectedRoute = () => {
    const auth = localStorage.getItem('isAuth') === 'authenticated'; // determine if authorized, from context or however you're doing it
    // If authorized, return an outlet that will render child elements
    // If not, return element that will navigate to login page
    return auth ? <Layout /> : <Navigate to="/login" />;
}
export default ProtectedRoute;